import styled from 'styled-components';
import TooltipBubble from './TooltipBubble';

const TooltipBottom = styled(TooltipBubble)`
  top: ${({ locationTop }) => locationTop || '100%'};
  left: 50%;
  padding-top: 9px;
  transform: translateX(-50%);

  &::after {
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 9px solid rgba(0, 0, 0, 0.7);
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export default TooltipBottom;
